import React from 'react';

export default function StatusBadge({ status }) {
  const normalized = (status || '').replace('_approval', '');
  // className keeps the raw value (badge-past_due matches styles.css) --
  // only the visible label gets the underscore swapped for a space.
  return <span className={`badge badge-${normalized}`}>{(status || '').replace(/_/g, ' ')}</span>;
}
